import React from "react";
import { Button } from "../../common/Button/Button";
import moment from "moment";
import Spinner from "../../common/Spinner/Spinner";
import { useEffect,useState } from "react";
import { toast } from "react-toastify";
import api from "../../utils/api";
import ESPFollowUpsGrid from "../../components/EServicePartnerServiceRequests/ESPFollowUpsGrid";
import { getESPUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import ConfirmationModalSmall from "../../components/ServicePackaging/ConfirmationModalSmall";

export default function ESPFollowUpsContainer(props)
{
    const [fromDate, setfromDate] = useState(props.fromDate);
    const [toDate, settoDate] = useState(props.toDate);  
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [FollowUpsData, setFollowUpsData] = useState([]);
    const [pages, setPages] = useState(0);
    const [currentPage, setcurrentPage] = useState(0);
	const [pageSize, setPageSize] = useState(10);
    const [tableInstance, setTableInstance] = useState(null);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const toggleConfirmationModal = () => {setShowConfirmationModal(!showConfirmationModal);};
    const [selectedServiceForFollowUp, setSelectedServiceForFollowUp] = useState();

    useEffect(() => {
        if (!getESPUser()) 
        {
            history.push("/service_partner/login");
        }
        else
        {
            getESPFollowUpsData()
        }
        
	},[]);

    const getESPFollowUpsData=()=>{
       
        /*let filterParameters={}

        if(fromDate)
        {
            filterParameters.fromDate=fromDate;
        }

        if(toDate)
        {
            filterParameters.toDate=adjustedToDate(toDate);
        }*/

        setIsLoading(true);	
        const { tempServices } = api.getSPLedFollowUps().then(({ data }) => {
            setIsLoading(false);
			if(data)
            {
                setFollowUpsData(data);               
            }
		}).catch((error) =>
        {
            setIsLoading(false);
            if(error.response.data.detail)
            {
                toast(String(error.response.data.detail), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else if(error.response.data.message)
            {
                toast(String(error.response.data.message), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else
            {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }            
        });
    }

    const adjustedToDate = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
				)
			);
		}
		return toDateAdjusted;
	};

    const handleSaveFollowUp = async (e,service) => {
        toggleConfirmationModal();
        setSelectedServiceForFollowUp(service);
	};

    const onFollowUpSave = async () => 
    {
        toggleConfirmationModal();
        
        let payload={
            bHandled:true,
            nResourceInstanceId:selectedServiceForFollowUp.nResourceInstanceId,
            dtFollowupOn:selectedServiceForFollowUp.dtFollowupOn,
            nFollowupId:selectedServiceForFollowUp.id
        }
        UpdateFollowUp(payload);
    };

    const UpdateFollowUp = async (payload) => {
        try
        {            
            setIsLoading(true);
            const { data: _ignore_ } = await api
                .updateSPFollowUpData(payload)
                .then((d) => {
                    if (d.data) 
                    {
                        setIsLoading(false);
                        toast("Follow up updated successfully.", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                        getESPFollowUpsData(); 
                    }
                })
                .catch((error) =>
                {
                    setIsLoading(false);
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        } 
        catch (error)
        {
            setIsLoading(false);
        }            
    };

    return (
        <div className={`row row-container ${isLoading && "set-opacity"}`} >
			{isLoading && <Spinner className="center-screen" />}
            <div className="col-12 service-partner spled-container conv-mt10">
                <ESPFollowUpsGrid
                    data={FollowUpsData}
                    //fetchESPCustomerFeedbackData={fetchESPCustomerFeedbackData}
                    pages={pages}
                    pageSize={pageSize}
                    page={currentPage}
                    //changePage={changePage}
                    //pageSizeOptions={pageSizeOptions}
                    //selectedPageSizeOption={selectedPageSizeOption}
                    /*onPageSizeOptionChange={(option) => {
                        setSelectedPageSizeOption(option);
                    }}*/
                    handleSaveFollowUp={handleSaveFollowUp}
                />

                <ConfirmationModalSmall
                    message={"Do you want to mark this follow up as completed?"}
                    isOpen={showConfirmationModal}
                    toggleModal={toggleConfirmationModal}
                    onPositive={onFollowUpSave}
                    buttonText={"Yes"}
                />
            </div>
            
       </div>
    )
}